export const TextParams = {
  FONT_REGULAR: "Lato-Regular",
  FONT_BOLD: "Lato-Bold",
  ALIGN_CENTER: "center",
  SIZE_SM: 12,
  SIZE_MD: 14,
  SIZE_XL: 27,
}

export const SEAT = {
  size: 35,
  margin: 10,
  color: "white",
  strokeWidth: 1,
  fontSize: TextParams.SIZE_MD,
};

export const SEAT_ICONS = {
  INVALID: "\ue919",
  BROKEN: "\ue928",
};

export const BOX = {
  defaultSize: 115,
  minSize: 75,
  maxSize: 195,
  nameFontSize: 20,
};

export const buttonSize = 45;

export const buttonsList = [
  {
    imageUrl: "/img/edit_icon2.svg",
    type: "editAction",
    x: 0,
    y: 0,
  },
  {
    imageUrl: "/img/copy_icon2.svg",
    type: "copyAction",
    x: 0,
    y: 0,
  },
  {
    imageUrl: "/img/freeze_icon.svg",
    type: "freezeAction",
    x: 0,
    y: 0,
  },
  {
    imageUrl: "/img/sort_icon2.svg",
    type: "sortAction",
    x: 0,
    y: 0,
  },
  {
    imageUrl: "/img/delete_icon2.svg",
    type: "deleteAction",
    x: 0,
    y: 0,
  }
]

export const actionsTypes = ["editAction",  "copyAction",  "freezeAction",  "sortAction",  "deleteAction"];

export const buttonsOrder = {
  "section": ['editAction', 'copyAction', 'freezeAction', 'sortAction', 'deleteAction'],
  "round": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "square": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "rectangle": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "area": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "box": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "text": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "stage": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
  "partition": ['editAction', 'copyAction', 'freezeAction', 'deleteAction'],
}

export const transformLimit = {
  'stage': [160, 60, 4000, 800],
  'stageRectangular': [100, 40, 4000, 800],
  'area': [200,200,4000,4000],
  'box': [BOX.minSize, BOX.minSize, BOX.maxSize, BOX.maxSize],
  'partition': [3, 20, 20, 4000],
}

export const anchorsPoint = {
  'stage': [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "middle-right",
    "middle-left",
    "top-center",
    "bottom-center",
  ],
  'area': [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "middle-right",
    "middle-left",
    "top-center",
    "bottom-center",
  ],
  'box': [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "middle-right",
    "middle-left",
    "top-center",
    "bottom-center",
  ],
  'partition': [
    "middle-right",
    "middle-left",
    "top-center",
    "bottom-center"
  ]
} 

